/* eslint-disable react/jsx-props-no-spreading */
/**
 * Props spreading is required because the parent component is fully customizable
 * So, we need to pass all the props to the parent component
 * That are typed as React.HTMLAttributes<HTMLDivElement>, the correct
 * types for a div element.
 */
import React from 'react';
import clsx from 'clsx';
import { FileIcon, FolderIcon } from './FileExplorerIcons';

interface FileExplorerGridItemProps extends React.HTMLAttributes<HTMLDivElement> {
  kind: 'file' | 'folder';
  nodeTitle: string;
  actionsDropdown: React.ReactNode;
  isNewlyAdded?: boolean;
}

export function FileExplorerGridItem(
  { kind, isNewlyAdded, ...props }: FileExplorerGridItemProps) {
  const { actionsDropdown, nodeTitle, ...rest } = props;

  const icon = kind === 'file'
    ? <FileIcon height={30} width={30} />
    : <FolderIcon height={30} width={30} />;

  return (
    <div
      className={clsx('file-explorer-grid-item')}
      data-newly-added={isNewlyAdded}
      title={nodeTitle}
      {...rest}
    >
      <div className="file-explorer-grid-item__header">
        {actionsDropdown}
      </div>
      <div className="file-explorer-grid-item__body">
        {icon}
      </div>
      <div className="file-explorer-grid-item__footer">
        {nodeTitle}
      </div>
    </div>
  );
}
